module.exports = __webpack_public_path__ + "static/media/rep-centre-logo.948ba004.gif";